import { Component, inject } from '@angular/core';
import { DocumentTypePerActivityService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  DocumentTypePerActivityCreateDto,
  DocumentTypePerActivityDto,
  DocumentTypePerActivityExcelDownloadDto,
  DocumentTypePerActivityUpdateDto,
} from '../proxy/controlling/dtos/document-type-per-activity';
import { DOCUMENTTYPEPERACTIVITY_CONFIG, DOCUMENTTYPEPERACTIVITY_FIELDS } from './document-type-per-activity.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-document-type-per-activity',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, DocumentTypePerActivityService, ConfirmationService],
  templateUrl: './document-type-per-activity.html',
  styleUrl: './document-type-per-activity.scss',
})
export class DocumentTypePerActivity extends BaseHierarchicalCrudComponent<
  DocumentTypePerActivityDto,
  DocumentTypePerActivityCreateDto,
  DocumentTypePerActivityUpdateDto,
  DocumentTypePerActivityExcelDownloadDto
> {
  service = inject(DocumentTypePerActivityService);
  config = DOCUMENTTYPEPERACTIVITY_CONFIG;
  fields = DOCUMENTTYPEPERACTIVITY_FIELDS;

  protected prepareUpdateDto(data: any, selected: DocumentTypePerActivityDto): DocumentTypePerActivityUpdateDto {
    return {
      documentTypeId: data.documentTypeId,
      activityId: data.activityId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'DocumentTypePerActivity';
  }
}
